/**
 * Filter tags name their hue with a `color` (e.g. 'blue'), which stands for the matching
 * --tag-* accent in App.scss. Resolving it here means a tag never has to know how the
 * palette is spelled, and the pill and the content it filters can't drift apart.
 */

/** Hues that stand for "no filter applied", so the content they select stays untinted. */
const UNTINTED_COLORS = ['neutral'];

/**
 * Resolves a tag's color name to the CSS accent variable it stands for
 * @param {string} [color] - The tag's color name (e.g. 'blue')
 * @returns {string|null} - A CSS var() reference, or null when the tag has no hue
 */
export const getTagAccentVar = (color) => (color ? `var(--tag-${color})` : null);

/**
 * Finds the accent of the selected tag, for tinting the content that tag filters down to.
 * Untinted hues (All) resolve to null so the unfiltered view keeps its default look
 * @param {Array} tags - The tags shown in the group
 * @param {string} selectedTagId - The _id of the currently selected tag
 * @returns {string|null} - A CSS var() reference, or null when nothing should be tinted
 */
export const getSelectedTagAccentVar = (tags = [], selectedTagId) => {
  const selectedTag = tags.find((tag) => tag._id === selectedTagId);

  if (!selectedTag || UNTINTED_COLORS.includes(selectedTag.color)) return null;

  return getTagAccentVar(selectedTag.color);
};
